import "core-js/modules/es.string.match";

var iOSDeviceInputSelect = function iOSDeviceInputSelect(input) {
  var editable = input.contentEditable;
  var readOnly = input.readOnly;
  var range = document.createRange();
  var selection = window.getSelection();
  input.contentEditable = true;
  input.readOnly = false;
  range.selectNodeContents(input);
  selection.removeAllRanges();
  selection.addRange(range);
  input.setSelectionRange(0, input.value.length);
  input.contentEditable = editable;
  input.readOnly = readOnly;
};

var copyToClipboard = function copyToClipboard(textareaToCopy) {
  var input = document.querySelector(textareaToCopy);
  var isiOSDevice = navigator.userAgent.match(/i(pad|phone|pod)/i);

  if (input) {
    if (isiOSDevice) {
      iOSDeviceInputSelect(input);
    } else {
      input.select();
    }

    document.execCommand('copy');
    input.blur();
  }
};

export default copyToClipboard;